const adapt = httpResponse => {
  const { response } = httpResponse;
  return {
    ...httpResponse,
    response,
  };
};

const checkAdapter = httpResponsePromise =>
  httpResponsePromise.then(
    resolve => adapt(resolve),
    reject => Promise.reject(adapt(reject)),
  );

export { checkAdapter };
